<template>
    <div id="collapseImprove" class="accordion-collapse collapse " aria-labelledby="headingImprove">
        <div class="accordion-body p-2">
            <h5>Improve this question.</h5>
            <p class="text-muted">
                What is the main problem with this question?
            </p>
            <div class="alert alert-danger" v-if="error_message !== null">
                {{ error_message }}
            </div>

            <div class="mb-2">
                <b>Suggestions:</b>
                <div class="tags">
                <span v-for="suggestion in suggestions" :key="suggestion" class="badge badge-primary"
                      @click="fillSuggestion(suggestion)">
                    <i class="ti ti-plus me-2"></i> {{ suggestion }}
                </span>
                </div>
            </div>

            <form @submit.prevent="create">
                <div class="mb-2">
                    <textarea v-model="item.suggestion" class="form-control"
                              :class="{ 'is-invalid' : isInvalid('suggestion')}"  ref="suggestionTextArea"></textarea>
                    <div class="invalid-feedback" v-if="isInvalid('suggestion')">
                        {{ isInvalid('suggestion') }}
                    </div>
                </div>
                <button type="submit" class="btn btn-primary">Submit suggestions</button>
            </form>
        </div>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    props: {
        question: {
            required: true
        }
    },
    data() {
        return {
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
            suggestions: [
                "The question is too broad: ",
                "The question lacks details: ",
                "The question is not clear: ",
                "The question is too subjective: "
            ]
        }
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        fillSuggestion(suggestion) {
            this.item.suggestion = suggestion;
            this.$nextTick(() => {
                this.$refs.suggestionTextArea.focus();
            });
        },
        create() {
            const id = toast.info('creating ...', {icon: 'fa-solid fa-cloud-arrow-up'});

            this.validationErrors = null;
            this.error_message = null;

            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            formData.append('question_id', this.question?.id);
            formData.append('subscribe_id', this.$route.params?.subscribe_id);

            axios.post('question_suggestions', formData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, {
                        timeout: 3000,
                        icon: 'fa-solid fa-circle-check'
                    });

                    this.item = {};
                })
                .catch(error => {
                    toast.dismiss(id);
                    if (error.response) {
                        this.validationErrors = error.response.data.errors;
                        this.error_message = error.response.data.message;
                        toast.error(error.response.data.message, {
                            timeout: 3000,
                            icon: 'fa-solid fa-circle-exclamation'
                        });
                    }
                });
        }
    }
}
</script>

<style>
.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.badge {
    cursor: pointer;
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border-radius: 0.25rem;
}

.badge:hover {
    background-color: #0056b3;
}
</style>
